import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ReAccountingStatus } from '@work4all/models/lib/Enums/ReAccountingStatus.enum';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

type Props<TMultiple extends boolean> = IPickerProps<
  { id: string; name: string },
  TMultiple
>;

export function ReAccountingStatusPicker<TMultiple extends boolean>(
  props: Props<TMultiple>
) {
  const { t } = useTranslation();
  const data = useMemo(() => {
    return Object.keys(ReAccountingStatus)
      .map((key) => {
        const id = ReAccountingStatus[key];

        return {
          id,
          name: t(`RE.ACCOUNTING_STATUSES.${id}`),
        };
      })
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [t]);

  return <FixedDataPicker dataSet={data} {...props} />;
}
